import { Table, TableProps } from '@chakra-ui/table';
import React from 'react';

export const CmTable: React.FC<TableProps> = ({ ...rest }) => {
  // @ts-ignore TS2590
  return <Table {...rest} />;
};
